import { useCallback } from "react";
import { Grid, Divider, Typography } from "@material-ui/core";
import { Box, Button, List, ListItem } from "~/components/UI";
import Highlighter from "react-highlight-words";
import history from "~/packages/history";
import ROUTES from "~/constants/routes";
import { useTranslation } from "react-i18next";

interface GroupsResultProps {
  data?: Api.SearchResult<GroupsApi.GroupDto>;
  searchQuery: string;
}

const Group = ({
  group,
  searchQuery,
}: {
  searchQuery: string;
  group: GroupsApi.GroupDto;
}) => {
  const openGroup = useCallback(() => {
    history.push(`${ROUTES.GROUPS}?groupId=${group.groupId}`);
  }, [group.groupId]);

  return (
    <ListItem button onClick={openGroup}>
      <Typography variant="body2" color="textSecondary">
        <Highlighter searchWords={[searchQuery]} textToHighlight={group.name} />{" "}
        [
        <Typography variant="body2" component="span" color="primary">
          ID
        </Typography>
        :{" "}
        <Highlighter
          searchWords={[searchQuery]}
          textToHighlight={group.groupId}
        />
        ]
      </Typography>
      <Divider />
    </ListItem>
  );
};

/**
 * @memberof GlobalSearch
 * @component
 * @desc Render of search results for the Groups catalog.
 * @property {string} searchQuery - the text we are looking for
 * @property {Api.SearchResult<GroupsApi.GroupDto>} data - api response
 */

const Groups = ({ data, searchQuery }: GroupsResultProps) => {
  const { t } = useTranslation();

  const onShowAll = useCallback(() => {
    setTimeout(() => {
      history.push(`${ROUTES.GROUPS}?search=${searchQuery}`);
    }, 0);
  }, [searchQuery]);

  if (data && data.count) {
    return (
      <Box mb={4}>
        <Box py={4}>
          <Grid container alignItems="center">
            <Grid item sm>
              <Typography variant="subtitle1">
                {t("title.catalogGroups")} ({data.count})
              </Typography>
            </Grid>
            <Grid item>
              <Button variant="outlined" onClick={onShowAll}>
                {t("button.showAll")}
              </Button>
            </Grid>
          </Grid>
        </Box>
        <List>
          {data.data.map((g, index) => (
            <Group key={index} searchQuery={searchQuery} group={g} />
          ))}
        </List>
      </Box>
    );
  } else {
    return null;
  }
};

export default Groups;
